<template>
  <Card
    shadow
    :style="{height: '90px', borderRadius: '0',  borderTop: '1px solid #F2F2F2'}"
    :padding="0"
  >
    <Row
      v-if="item.type == 'event'"
      style="float:right;textAlign:center;padding:5px;height:58px;width: 40px;marginRight:10px;lineHeight:1;display: inline-block;"
    >
      <div
        style="vertical-align: baseline;color:red;vertical-align:middle;font-size: 12px;margin-top: 3px;"
      >{{getMonthEvent}}</div>
      <div
        style="text-align: center;font-size: 22px;display: flex;align-items: center;justify-content: center;"
      >{{getDayEvent}}</div>
      <div style="vertical-align: middle;font-size: 10px;align-self: self-end;">{{getYearEvent}}</div>
    </Row>
    <div
      class="resources-item-header pointer"
      :style="{padding: '10px 10px 8px'}"
      @click="viewResource(item)"
    >
      <!-- <Icon type="chevron-right" style="float:right;line-height:40px"></Icon> -->
      <a>
        <Avatar
          class="resource-avatar"
          shape="square"
          :src="previewImage(item)"
          style="width:70px;height:70px"
          :style="{float:'left', marginRight: '10px'}"
        />
      </a>
      <p
        class="truncate"
        style="padding-right:20px:    line-height: 40px;"
        :style="{marginRight: '35px'}"
      >{{title || item.title}}</p>
      <small style="color:#aaa;width: 100%;" v-if="!isPeople">
        <!-- <b>{{item.submitted.display_name}}</b> &nbsp; -->
        <span
          style="color:#2d8cf0;font-size: 15px;"
          v-if="userInfo.user_type !== 'guest' && (item.type == 'event' && item.status == 'accepted')"
        >
          <i class="fas fa-check-circle"></i>
        </span>
        <span
          style="float:right;color:#2d8cf0;vertical-align:middle;margin-top:-10px;margin-right:5px;font-size: 15px"
          v-if="userInfo.user_type !== 'guest' && item.subscribed && item.type != 'event'"
        >
          <i class="fas fa-check-circle"></i>
        </span>
      </small>
    </div>
  </Card>
</template>

<script>
import Utils from "@/utils.js";
import moment from "moment";
export default {
  name: "ResourceListItemComponent",
  props: {
    item: {
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },
  computed: {
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    getMonthEvent: {
      get() {
        if (
          this.item &&
          this.item.pages &&
          this.item.pages[0] &&
          this.item.pages[0].data &&
          this.item.pages[0].data.event_start_date
        ) {
          return Utils.parseDateToMonth(
            new Date(this.item.pages[0].data.event_start_date)
          );
        } else {
          return "";
        }
      }
    },
    getDayEvent: {
      get() {
        if (
          this.item &&
          this.item.pages &&
          this.item.pages[0] &&
          this.item.pages[0].data &&
          this.item.pages[0].data.event_start_date
        ) {
          return Utils.parseDateToDay(
            new Date(this.item.pages[0].data.event_start_date)
          );
        } else {
          return "";
        }
      }
    },
    getYearEvent: {
      get() {
        if (
          this.item &&
          this.item.pages &&
          this.item.pages[0] &&
          this.item.pages[0].data &&
          this.item.pages[0].data.event_start_date
        ) {
          return Utils.parseDateToYear(
            new Date(this.item.pages[0].data.event_start_date)
          );
        } else {
          return "";
        }
      }
    },
    isPeople: {
      get() {
        return this.$route.query.type == "people";
      }
    }
  },
  methods: {
    previewImage(item) {
      return item.thumbnail_photo ? item.thumbnail_photo[0].small : item.avatar ? item.avatar : null;
    },
    viewResource(item) {
      if (this.isPeople) {
        this.$router.push({
          path: "/people",
          query: { id: this.item.id, type: this.$route.query.type }
        });
      } else if (this.item.type == "event") {
        this.$store.commit("resource/setSingleGroup", item);
        this.$router.push({
          path: "/resources/" + item.id,
          query: { type: this.item.type }
        });
      } else if (item.type == "organization" || item.unique_identifier) {
        this.$store.commit("resource/setSingleGroup", item);
        let organizationId = this.item.unique_identifier ? item.careplan_id : item.id
        this.$router.push({
          path: "/organization/" + organizationId,
          query: {  
            t: "home"
          }
        });
      }
      else {
        this.$store.commit("resource/setSingleGroup", item);
        this.$router.push({
          path: "/resources/" + item.id
        });
      }
    }
  }
};
</script>


<style lang="scss" scoped>
/deep/ .resource-avatar {
  img {
    object-fit: cover;
  }
}
</style>
